import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './BrandSuitabilityFour.style';

const BrandSuitabilityFour = () => {
  const { t } = useTranslation('brandSuitability');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('brandSuitabilityFour.title')}</h1>
        <StyledHr />
      </SectionWrapper>
      <ContentWrapper>
        <div>
          <TextBox1>
            <p>
              <span>1.</span>
              {t('brandSuitabilityFour.paragraphOne.title')}
            </p>
            <TextBox2>
              <p>{t('brandSuitabilityFour.paragraphOne.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1>
            <p>
              <span>2.</span>
              {t('brandSuitabilityFour.paragraphTwo.title')}
            </p>
            <TextBox2>
              <p>{t('brandSuitabilityFour.paragraphTwo.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>

        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>
              <span>3.</span>
              {t('brandSuitabilityFour.paragraphThree.title')}
            </p>
            <TextBox2>
              <p>{t('brandSuitabilityFour.paragraphThree.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>
              <span>4.</span>
              {t('brandSuitabilityFour.paragraphFour.title')}
            </p>
            <TextBox2>
              <p>{t('brandSuitabilityFour.paragraphFour.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSuitabilityFour;
